export default "__VITE_ASSET__BHQkj1up__"